<lottie-animation-view [options]="lottieConfig" [width]="80" [height]="80"></lottie-animation-view>
